import React, { useContext } from "react";
import { UsuarioContext } from "config/context/UsuarioProvider";
// *** @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// ***  @material-ui/icons
import DatosFacturacion from "./sectionsCompra05/DatosFacturacion";

// *** core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

// *** Imagenes
import imgDatosEmpresaFea from "assets/img/com-fea/img-datos-empresa.png";
import imgDatosEmpresa from "assets/img/com-fes/img-datos-empresa.png";
// *** Styles
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
const useStyles = makeStyles(basicsStyle);
const useStyles2 = makeStyles(featuresStyle);

export default function FacturacionPago() {
  const classes = useStyles();
  const classes2 = useStyles2();
  const { planUser } = useContext(UsuarioContext);
  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes2.features3}>
            {planUser === "CFES" ? (
              <img src={imgDatosEmpresa} alt="..." />
            ) : (
              <img src={imgDatosEmpresaFea} alt="..." />
            )}
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes.title}>
            <h3 style={{fontWeight: "400"}}>Datos Facturación</h3>
          </div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <DatosFacturacion />
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
